(function () {
  if (window.formEmbedLoaderInitialized) return;
  window.formEmbedLoaderInitialized = true;
  function loadRemoteScript() {
    if (document.getElementById('ghl-form-embed')) return;
    var script = document.createElement('script');
    script.id = 'ghl-form-embed';
    script.src = 'https://link.msgsndr.com/js/form_embed.js';
    script.async = true;
    document.head.appendChild(script);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadRemoteScript);
  } else {
    loadRemoteScript();
  }
})();
